export const actions = {
  set: 'SET::MENU_SELECTED_STATE'
}

export const setMenuSelectedState = state => ({ type: actions.set, menuSelectedState: state })
export const getMenuSelectedState = state => state.menuSelectedState

export default actions



// WEBPACK FOOTER //
// ./src/store/menu-selected/actions.js